var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"ui-type-caption text-gray-600"},[_vm._v(" "+_vm._s(_vm.toUpper(_vm.parentCategory()))+" ")]),_c('div',[_vm._v(_vm._s(_vm.category()))])])}
var staticRenderFns = []

export { render, staticRenderFns }